import { Fragment, useState } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import config from '../../config'
import { Row, Col, Card, Button, Form, Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import BoxOptionsModal from './boxOptionsModal'
import LotteryModal from './lotteryModal'
import FeeRateConfig from './feeRateConfig'
import { createRound } from '../../services/config-services'
import ExtractSeriesModal from './ExtractSeriesModal'
import ImportSeriesByNumberModal from './ImportSeriesByNumberModal'

const Round = () => {
  const [date, setDate] = useState(null)
  const [createdRoundModalVisible, setCreateRoundModalVisible] = useState(false)
  const [dateError, setDateError] = useState()
  const [isShowImportSingleLottery, setIsShowImportSingleLottery] = useState(false)
  const [isShowImportSeriesLottery, setIsShowImportSeriesLottery] = useState(false)
  const [isShowImportNumberLottery, setIsShowImportNumberLottery] = useState(false)
  const [isShowImportBox, setIsShowImportBox] = useState(false)
  const [isShowCountTemp, setIsShowCountTemp] = useState(false)
  const [isShowImportBoxLast2Digits, setShowImportBoxLast2Digits] = useState(false)
  const [isShowExtractSeries, setIsShowExtractSeries] = useState(false)
  const [lotterySingleErrorMessage, setLotterySingleErrorMessage] = useState(null)
  const [lotterySeriesErrorMessage, setLotterySeriesErrorMessage] = useState(null)

  const dispatch = useDispatch()

  const handleOnClickedAddRoundDate = async () => {
    try {
      dispatch({ type: 'loading_show' })
      if (!date) throw new Error(setDateError('จำเป็นต้องใส่รอบ'))
      await createRound(new Date(date))
      setCreateRoundModalVisible(false)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      console.log('Error while trying to fetch orders.')
      dispatch({ type: 'loading_hide' })
    }
  }

  async function handleOnClickImportLotterySingle() {
    dispatch({ type: 'loading_show' })
    const elLotterySingleQuantity = document.querySelector('#lotterySingleQuantity')
    const isNum = /^\d+$/.test(elLotterySingleQuantity.value)
    if (!isNum || elLotterySingleQuantity.value < 1) {
      return setLotterySingleErrorMessage('กรุณาตรวจสอบจำนวนหวยที่จะนำเข้าสู่ระบบ')
    }
    if (elLotterySingleQuantity.value > 50000) {
      return setLotterySingleErrorMessage('จำนวนนำเข้าต้องไม่เกิน 50,000 ใบ')
    }
    try {
      await axios.post(
        `${config.apiAdminGateway}/api/v2/admin/lotteries/publish`,
        {
          count: 1,
          amount: parseInt(elLotterySingleQuantity.value),
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      setLotterySeriesErrorMessage(null)
      setIsShowImportSeriesLottery(false)
      dispatch({ type: 'loading_hide' })
    } catch (err) {
      setLotterySingleErrorMessage(err.message)
    }
    setIsShowImportSingleLottery(false)
    dispatch({ type: 'loading_hide' })
  }

  async function handleOnClickImportMysteryBoxLast2Digits() {
    dispatch({ type: 'loading_show' })
    const eMysteryBoxLast2DigitsQuantity = document.querySelector('#mysteryBoxLast2DigitsQuantity')
    const isNum = /^\d+$/.test(eMysteryBoxLast2DigitsQuantity.value)
    if (!isNum || eMysteryBoxLast2DigitsQuantity.value < 1) {
      dispatch({ type: 'loading_hide' })
      return alert('กรุณาตรวจสอบจำนวนหวยที่จะนำเข้าสู่ระบบ')
    }
    if (eMysteryBoxLast2DigitsQuantity.value > 1000) {
      dispatch({ type: 'loading_hide' })
      return alert('จำนวนนำเข้าต้องไม่เกิน 1,000 กล่อง')
    }
    try {
      await axios.post(
        `${config.apiAdminGateway}/api/v1/admin/publish/mysterybox/last2digits`,
        {
          amount: parseInt(eMysteryBoxLast2DigitsQuantity.value),
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      setShowImportBoxLast2Digits(false)
      alert(`สร้างกล่องสุมเลขท้าย 2 ตัว จำนวน ${parseInt(eMysteryBoxLast2DigitsQuantity.value)} กล่องสำเร็จ`)
    } catch (err) {
      return alert(err.message)
    } finally {
      dispatch({ type: 'loading_hide' })
    }
    setShowImportBoxLast2Digits(false)
  }

  async function handleOnClickImportLotterySeries() {
    dispatch({ type: 'loading_show' })
    const elLotterySeriesQuantity = document.querySelector('#lotterySeriesQuantity')
    const elLotterySeriesCount = document.querySelector('#lotterySeriesCount')
    const isNum = /^\d+$/.test(elLotterySeriesQuantity.value)
    const isNumCount = /^\d+$/.test(elLotterySeriesCount.value)
    if (!isNum || elLotterySeriesQuantity.value < 1) {
      return setLotterySeriesErrorMessage('กรุณาตรวจสอบจำนวนหวยที่จะนำเข้าสู่ระบบ')
    }
    if (!isNumCount || elLotterySeriesCount.value < 1) {
      return setLotterySeriesErrorMessage('กรุณาตรวจสอบจำนวนชุดที่จะนำเข้าสู่ระบบ')
    }
    if (elLotterySeriesQuantity.value > 50000) {
      return setLotterySeriesErrorMessage('จำนวนนำเข้าต้องไม่เกิน 50,000 ชุด')
    }
    try {
      await axios.post(
        `${config.apiAdminGateway}/api/v2/admin/lotteries/publish`,
        {
          count: parseInt(elLotterySeriesCount.value),
          amount: parseInt(elLotterySeriesQuantity.value),
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      setLotterySeriesErrorMessage(null)
      setIsShowImportSeriesLottery(false)
      dispatch({ type: 'loading_hide' })
    } catch (err) {
      setLotterySingleErrorMessage(err.message)
    }
  }

  return (
    <Fragment>
      <Modal show={isShowImportSingleLottery} onHide={() => setIsShowImportSingleLottery(false)} centered>
        <Modal.Header>
          ยืนยัน เอาหวยเดี่ยวเข้าระบบ
          <Button variant="" className="close" onClick={() => setIsShowImportSingleLottery(false)}>
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label>จำนวนลอตเตอรี่ (ไม่เกิน 50,000 ใบ)</Form.Label>
            <Form.Control id="lotterySingleQuantity" placeholder="ใส่จำนวนลอตเตอรี่" />
            <div
              className="d-flex align-items-center justify-content-end text-danger"
              style={{ fontSize: '12px', height: '36px' }}
            >
              {lotterySingleErrorMessage && <span>{lotterySingleErrorMessage}</span>}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger light"
            onClick={() => {
              setLotterySingleErrorMessage(null)
              setIsShowImportSingleLottery(false)
            }}
          >
            ยกเลิก
          </Button>
          <Button
            variant="primary light"
            onClick={async () => {
              await handleOnClickImportLotterySingle()
            }}
          >
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={isShowImportBoxLast2Digits} onHide={() => setShowImportBoxLast2Digits(false)} centered>
        <Modal.Header>
          ยืนยัน กล่องสุ่มเลขท้าย 2 ตัวเข้าระบบ
          <Button variant="" className="close" onClick={() => setShowImportBoxLast2Digits(false)}>
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label>จำนวนกล่องสุ่ม (ไม่เกิน 1,000 กล่อง)</Form.Label>
            <Form.Control id="mysteryBoxLast2DigitsQuantity" placeholder="ใส่จำนวนกล่องสุ่มที่จะสร้าง" />
            <div
              className="d-flex align-items-center justify-content-end text-danger"
              style={{ fontSize: '12px', height: '36px' }}
            >
              {lotterySingleErrorMessage && <span>{lotterySingleErrorMessage}</span>}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger light"
            onClick={() => {
              setLotterySingleErrorMessage(null)
              setShowImportBoxLast2Digits(false)
            }}
          >
            ยกเลิก
          </Button>
          <Button
            variant="primary light"
            onClick={async () => {
              await handleOnClickImportMysteryBoxLast2Digits()
            }}
          >
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
      <ImportSeriesByNumberModal show={isShowImportNumberLottery} onHide={() => setIsShowImportNumberLottery(false)} />
      <Modal show={isShowImportSeriesLottery} onHide={() => setIsShowImportSeriesLottery(false)} centered>
        <Modal.Header>
          ยืนยันเอาหวยชุดเข้าระบบ
          <Button variant="" className="close" onClick={() => setIsShowImportSeriesLottery(false)}>
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label>จำนวนใบ (ไม่เกิน 50,000 ใบ)</Form.Label>
            <Form.Control id="lotterySeriesQuantity" placeholder="ใส่จำนวนลอตเตอรี่" />
            <Form.Label>จำนวนชุด</Form.Label>
            <Form.Control id="lotterySeriesCount" placeholder="ใส่จำนวนชุด" />
            <div
              className="d-flex align-items-center justify-content-end text-danger"
              style={{ fontSize: '12px', height: '36px' }}
            >
              {lotterySeriesErrorMessage && <span>{lotterySeriesErrorMessage}</span>}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger light"
            onClick={() => {
              setLotterySeriesErrorMessage(null)
              setIsShowImportSeriesLottery(false)
            }}
          >
            ยกเลิก
          </Button>
          <Button
            variant="primary light"
            onClick={async () => {
              await handleOnClickImportLotterySeries()
            }}
          >
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
      {isShowImportBox && <BoxOptionsModal isShowImportBox={isShowImportBox} setIsShowImportBox={setIsShowImportBox} />}
      {isShowExtractSeries && <ExtractSeriesModal {...{ isShowExtractSeries, setIsShowExtractSeries }} />}
      <Card>
        <Card.Body>
          <Row>
            <Col sm={8}>
              <Row>
                <Button className="mr-2" variant="success light" onClick={() => setIsShowImportSingleLottery(true)}>
                  เอาหวยเดี่ยวเข้าระบบ
                </Button>
                <Button className="mr-2" variant="info light" onClick={() => setIsShowImportSeriesLottery(true)}>
                  เอาหวยชุดเข้าระบบ
                </Button>
                <Button className="mr-2" variant="primary" onClick={() => setIsShowImportNumberLottery(true)}>
                  เอาหวยเลขท้ายเข้าระบบ
                </Button>
                <Button className="mr-2" variant="primary light" onClick={() => setShowImportBoxLast2Digits(true)}>
                  เอากล่องสุ่มเลขท้าย2ตัวเข้าระบบ
                </Button>
                <Button className="mr-2" variant="warning light" onClick={() => setIsShowImportBox(true)}>
                  เอากล่องเข้าระบบ
                </Button>
                <Button className="mr-2" variant="danger light" onClick={() => setIsShowExtractSeries(true)}>
                  แยกชุด
                </Button>
                <Button className="mr-2" variant="secondary light" onClick={() => setIsShowCountTemp(true)}>
                  นับยอดหวย
                </Button>
              </Row>
            </Col>
            <Col sm={4} className="d-flex justify-content-end">
              <Row>
                <Button className="mr-2" variant="primary light" onClick={() => setCreateRoundModalVisible(true)}>
                  <span className="mr-2">
                    <i className="fa fa-plus" />
                  </span>
                  เพิ่มรอบ
                </Button>
              </Row>
            </Col>

            <Modal className="fade" show={createdRoundModalVisible}>
              <Modal.Header>
                <Modal.Title>เพิ่มรอบ</Modal.Title>
                <Button variant="" className="close" onClick={() => setCreateRoundModalVisible(false)}>
                  <span>&times;</span>
                </Button>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group controlId="dob">
                      <Form.Label>รอบวันที่</Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        placeholder="Select date"
                        onChange={(e) => setDate(e.target.value)}
                      />
                    </Form.Group>
                    {!date && <span style={{ color: 'red' }}>{dateError}</span>}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => setCreateRoundModalVisible(false)} variant="danger light">
                  ยกเลิก
                </Button>
                <Button variant="primary" onClick={() => handleOnClickedAddRoundDate()}>
                  เพิ่มรอบ
                </Button>
              </Modal.Footer>
            </Modal>
          </Row>
          <br />
          <Card.Title>ปรับราคาหวย</Card.Title>
          <FeeRateConfig configName="fee-rate" />
          <Card.Title>ปรับราคากล่อง</Card.Title>
          <FeeRateConfig configName="box-price" />
        </Card.Body>
      </Card>
      <LotteryModal
        open={isShowCountTemp}
        onClose={() => {
          setIsShowCountTemp(false)
        }}
      />
    </Fragment>
  )
}

export default Round
